export const sizes = {
	md: { root: "py-2.5 px-3.5", shortcut: "pr-3" },
	sm: { root: "py-2 px-3", shortcut: "pr-2.5" },
};
